import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CustomValidator } from 'src/app/shared/directive/custom-validator';
import { APPLICATION } from 'src/app/shared/enums/admin-enum';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { ApplicationAccessStatusService } from 'src/app/shared/service/application-access-status.service';
import { UserSupplierService } from 'src/app/shared/service/user-supplier.service';
import { Spinner } from './../../../../../../core/services/spinner.service';

@Component({
  selector: 'app-revoke-access',
  templateUrl: './revoke-access.component.html',
  styleUrls: ['./revoke-access.component.scss']
})
export class RevokeAccessComponent implements OnInit {

  revokeAccessForm: FormGroup;
  apps: any[] = [];
  revokeByUser = false;
  listStatus: any[] = [];
  constructor(
    private userSupplierService: UserSupplierService,
    private spinner: Spinner,
    private activatedRoute: ActivatedRoute,
    private applicationAccessStatus: ApplicationAccessStatusService,
    private toastr: ToastrService
  ) {
    this.activatedRoute.params.subscribe(res => {
      if (res.id) {
        this.getUserById(res.id);
        this.revokeByUser = true;
      }
    });
  }

  ngOnInit() {
    this.initForm();
    this.getApplications();
  }

  public initForm(model?) {
    if (model) {
      this.revokeAccessForm = new FormGroup({
        sso: new FormControl(model.sso, [CustomValidator.required]),
        fullName: new FormControl(model.fullName),
        email: new FormControl(model.email),
        appName: new FormControl([model.appName], [CustomValidator.required]),
        reason: new FormControl('', [CustomValidator.required]),
      });
    } else {
      this.revokeAccessForm = new FormGroup({
        sso: new FormControl('', [CustomValidator.required]),
        fullName: new FormControl(),
        email: new FormControl(),
        appName: new FormControl('', [CustomValidator.required]),
        reason: new FormControl('', [CustomValidator.required]),
      });
    }
  }

  search() {
    this.spinner.show();
    this.applicationAccessStatus.searchSSO(this.revokeAccessForm.controls.sso.value).subscribe(res => {
      this.spinner.hide();
      if (res.data.length > 0) {
        this.revokeAccessForm.controls.fullName.setValue(res.data[0].fullName);
        this.revokeAccessForm.controls.email.setValue(res.data[0].email);
      } else {
        this.toastr.error(MESSAGE_TOAST.SSO_NOT_FOUND);
        this.revokeAccessForm.controls.sso.setValue('');
        this.revokeAccessForm.controls.fullName.setValue('');
        this.revokeAccessForm.controls.email.setValue('');
      }
    });
  }

  revokeAccess() {
    if (this.revokeAccessForm.invalid) {
      this.markFormGroupTouched(this.revokeAccessForm);
      return;
    }

    this.revokeAccessForm.controls.appName.value.forEach(item => {
      const model = {
        reason: this.revokeAccessForm.controls.reason.value,
        application: item,
        supplierSso: this.revokeAccessForm.controls.sso.value,
        fullName: this.revokeAccessForm.controls.fullName.value,
        email: this.revokeAccessForm.controls.email.value,
      };
      this.spinner.show();
      this.applicationAccessStatus.revokeAccess(model).subscribe(result => {
        if (result.status === 200) {
          this.spinner.hide();
          this.toastr.success('Request Access to ' + APPLICATION[result.data.application] + ' is sent successfully');
          this.getStatus(false);
        }
      });
    });
  }

  getUserById(id) {
    this.spinner.show();
    this.applicationAccessStatus.getSupplierById(id).subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        const model = {
          sso: res.data.sso,
          fullName: res.data.firstName + res.data.lastName,
          email: res.data.email,
          appName: res.data.application
        };
        this.initForm(model);
        this.getStatus(false);
      }
    });
  }

  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  getStatus(event) {
    if (!event) {
      const sso = this.revokeAccessForm.controls.sso.value;
      const appName = this.revokeAccessForm.controls.appName.value;
      if (sso && appName.length === 1) {
        this.applicationAccessStatus.getStatus(sso, appName).subscribe(res => {
          this.listStatus = res.data.map(item => {
            item.date = new Date(item.date).toLocaleString();
            return item;
          });
        });
      }
    }
  }

  public reloadStatus(event) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.getStatus(false);
  }

  getApplications() {
    this.spinner.show();
    this.applicationAccessStatus.getApplications().subscribe(res => {
      this.spinner.hide();
      if (res.data) {
        res.data = res.data.filter(app => app === 'RACES_ISUPPLIER');
        const array = [];
        // tslint:disable-next-line: forin
        for (const item of res.data) {
          array.push({
            value: item,
            name: APPLICATION[item]
          });
        }
        this.apps = array;
      }
    });
  }

}
